import { model_prospect } from "../../../../models";
import { Pessoa } from "../Pessoa";

export const Prospect = () => {
    return (
        <Pessoa model={model_prospect} />
    )
}